
(function () {
  'use strict';

  var PROG_PRZECIAGNIECIA = 40;
  var CZAS_PRZEJSCIA = 500;

  function bezRuchu() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function bezAutoodtwarzania() {
    return window.matchMedia('(max-width: 1023px)').matches;
  }

  var SKALA_MIN = 0.5;
  var SKALA_KROK = 0.02;

  function linie(el) {
    if (!el || !el.getClientRects().length) return 0;
    var wysokoscLinii = parseFloat(window.getComputedStyle(el).lineHeight) || 1;
    return Math.round(el.getBoundingClientRect().height / wysokoscLinii);
  }

  function wysokoscWPorzadku(blok) {
    var dzieci = [].filter.call(blok.children, function (el) { return el.getClientRects().length; });
    if (!dzieci.length) return true;
    var styl = window.getComputedStyle(blok);
    var r = blok.getBoundingClientRect();
    var gora = dzieci[0].getBoundingClientRect().top;
    var dol = dzieci[dzieci.length - 1].getBoundingClientRect().bottom;
    return gora >= r.top + parseFloat(styl.paddingTop) - 1 && dol <= r.bottom - parseFloat(styl.paddingBottom) + 1;
  }

  function miesciSie(blok) {
    return linie(blok.querySelector('.bh-hero__heading')) <= 2
      && linie(blok.querySelector('.bh-hero__sub')) <= 2
      && wysokoscWPorzadku(blok);
  }

  function dopasujBlok(blok) {
    blok.classList.remove('bh-hero__body--skrot');
    blok.style.removeProperty('--bh-hero-dopasuj');
    if (bezAutoodtwarzania()) return;
    var skala = 1;
    while (!miesciSie(blok) && skala > SKALA_MIN) {
      skala = Math.max(SKALA_MIN, Math.round((skala - SKALA_KROK) * 100) / 100);
      blok.style.setProperty('--bh-hero-dopasuj', String(skala));
    }
    if (linie(blok.querySelector('.bh-hero__sub')) > 2) blok.classList.add('bh-hero__body--skrot');
  }

  function Hero(korzen) {
    this.korzen = korzen;
    this.sekcja = korzen.closest('.bh-hero') || korzen;
    this.tor = korzen.querySelector('[data-bh-hero-track]');
    this.zakladki = [].slice.call(korzen.querySelectorAll('[data-bh-hero-tab]'));
    this.pasek = korzen.querySelector('[data-bh-hero-tablist]');
    this.pauza = korzen.querySelector('[data-bh-hero-pause]');
    this.poprzedni = korzen.querySelector('[data-bh-hero-prev]');
    this.nastepny = korzen.querySelector('[data-bh-hero-next]');

    this.slajdy = this.tor ? [].slice.call(this.tor.children) : [];
    this.indeks = 0;
    this.czas = parseInt(korzen.getAttribute('data-czas'), 10) || 6000;

    this.uchwyty = [];
    this.licznik = null;
    this.obserwator = null;
    this.wstrzymane = false;
    this.zFokusem = false;
    this.wWidoku = true;
    this.przeciaganie = null;
    this.aiOtwarte = null;
    this.aiPoza = null;

    this.podlacz();
  }

  Hero.prototype.nasluch = function (cel, nazwa, funkcja, opcje) {
    cel.addEventListener(nazwa, funkcja, opcje);
    this.uchwyty.push([cel, nazwa, funkcja, opcje]);
  };

  Hero.prototype.dopasujTekst = function () {
    [].forEach.call(this.korzen.querySelectorAll('.bh-hero__body--na-zdjeciu'), dopasujBlok);
  };

  Hero.prototype.podlacz = function () {
    if (!this.tor) return;
    this.podlaczAi();
    var self = this;
    var zaplanowane = false;
    var zaplanujDopasowanie = function () {
      if (zaplanowane) return;
      zaplanowane = true;
      window.requestAnimationFrame(function () {
        zaplanowane = false;
        self.dopasujTekst();
      });
    };
    this.dopasujTekst();
    this.nasluch(window, 'resize', zaplanujDopasowanie);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(zaplanujDopasowanie);
    if (this.slajdy.length < 2) return;

    this.tor.classList.add('bh-hero__track--sterowany');
    this.ustawSlajd(0, false);

    this.zakladki.forEach(function (przycisk, i) {
      self.nasluch(przycisk, 'click', function () {
        self.reczna();
        self.idzDo(i);
      });

      self.nasluch(przycisk, 'keydown', function (ev) {
        var cel = null;
        if (ev.key === 'ArrowRight') cel = (i + 1) % self.zakladki.length;
        else if (ev.key === 'ArrowLeft') cel = (i - 1 + self.zakladki.length) % self.zakladki.length;
        else if (ev.key === 'Home') cel = 0;
        else if (ev.key === 'End') cel = self.zakladki.length - 1;
        if (cel === null) return;
        ev.preventDefault();
        self.reczna();
        self.idzDo(cel);
        self.zakladki[cel].focus({ preventScroll: true });
      });
    });

    this.nasluch(this.tor, 'bh:do-kafla', function (ev) {
      if (!ev.detail || typeof ev.detail.indeks !== 'number') return;
      ev.preventDefault();
      self.reczna();
      self.idzDo(ev.detail.indeks);
    });

    if (this.poprzedni) {
      this.nasluch(this.poprzedni, 'click', function () {
        self.reczna();
        self.idzDo(self.indeks - 1);
      });
    }

    if (this.nastepny) {
      this.nasluch(this.nastepny, 'click', function () {
        self.reczna();
        self.idzDo(self.indeks + 1);
      });
    }

    if (this.pauza) {
      this.nasluch(this.pauza, 'click', function () {
        if (self.wstrzymane) self.wznow();
        else self.wstrzymaj();
      });
    }

    this.nasluch(this.korzen, 'focusin', function () {
      self.zFokusem = true;
      self.zamrozLicznik();
    });
    this.nasluch(this.korzen, 'focusout', function (ev) {
      if (ev.relatedTarget && self.korzen.contains(ev.relatedTarget)) return;
      self.zFokusem = false;
      self.wznowPoWstrzymaniu();
    });
    this.nasluch(this.korzen, 'touchstart', function () { self.reczna(); }, { passive: true });

    this.nasluch(this.tor, 'pointerdown', function (ev) { self.chwyt(ev); });
    this.nasluch(this.tor, 'pointermove', function (ev) { self.ruch(ev); });
    this.nasluch(this.tor, 'pointerup', function (ev) { self.puszczenie(ev); });
    this.nasluch(this.tor, 'pointercancel', function (ev) { self.puszczenie(ev); });

    this.nasluch(document, 'visibilitychange', function () {
      if (document.hidden) self.zamrozLicznik();
      else self.moznaLiczyc();
    });

    if ('IntersectionObserver' in window) {
      this.obserwator = new IntersectionObserver(function (wpisy) {
        self.wWidoku = wpisy[0].isIntersecting;
        if (self.wWidoku) self.moznaLiczyc();
        else self.zamrozLicznik();
      }, { threshold: 0.2 });
      this.obserwator.observe(this.sekcja);
    }

    this.moznaLiczyc();
  };

  Hero.prototype.podlaczAi = function () {
    var self = this;
    var przyciski = this.korzen.querySelectorAll('[data-bh-hero-ai]');
    if (!przyciski.length) return;

    [].forEach.call(przyciski, function (przycisk) {
      var okno = document.getElementById(przycisk.getAttribute('aria-controls'));
      if (!okno) return;
      var zamknij = okno.querySelector('[data-bh-hero-ai-zamknij]');

      self.nasluch(przycisk, 'click', function () {
        if (self.aiOtwarte && self.aiOtwarte.okno === okno) self.zamknijAi(true);
        else self.otworzAi(przycisk, okno);
      });
      [przycisk, okno].forEach(function (el) {
        self.nasluch(el, 'pointerdown', function (ev) { ev.stopPropagation(); });
        self.nasluch(el, 'touchstart', function (ev) { ev.stopPropagation(); }, { passive: true });
      });
      if (zamknij) {
        self.nasluch(zamknij, 'click', function () { self.zamknijAi(true); });
      }
    });

    this.nasluch(this.korzen, 'keydown', function (ev) {
      if (ev.key !== 'Escape' || !self.aiOtwarte) return;
      ev.preventDefault();
      self.zamknijAi(true);
    });

    this.aiPoza = function (ev) {
      var o = self.aiOtwarte;
      if (!o || o.okno.contains(ev.target) || o.przycisk.contains(ev.target)) return;
      self.zamknijAi(true);
    };
  };

  Hero.prototype.otworzAi = function (przycisk, okno) {
    if (this.aiOtwarte) this.zamknijAi(false);
    okno.hidden = false;
    przycisk.setAttribute('aria-expanded', 'true');
    this.aiOtwarte = { przycisk: przycisk, okno: okno };
    this.zamrozLicznik();
    document.addEventListener('pointerdown', this.aiPoza, true);
    okno.focus({ preventScroll: true });
  };

  Hero.prototype.zamknijAi = function (przywrocFokus) {
    var o = this.aiOtwarte;
    if (!o) return;
    this.aiOtwarte = null;
    document.removeEventListener('pointerdown', this.aiPoza, true);
    o.okno.hidden = true;
    o.przycisk.setAttribute('aria-expanded', 'false');
    if (!przywrocFokus) return;
    o.przycisk.focus({ preventScroll: true });
    var zKlawiatury = false;
    try { zKlawiatury = o.przycisk.matches(':focus-visible'); } catch (e) { zKlawiatury = true; }
    if (!zKlawiatury) this.zFokusem = false;
    this.wznowPoWstrzymaniu();
  };

  Hero.prototype.rozlacz = function () {
    this.zamknijAi(false);
    this.zatrzymajLicznik();
    if (this.obserwator) {
      this.obserwator.disconnect();
      this.obserwator = null;
    }
    for (var i = 0; i < this.uchwyty.length; i += 1) {
      var u = this.uchwyty[i];
      u[0].removeEventListener(u[1], u[2], u[3]);
    }
    this.uchwyty = [];
  };

  Hero.prototype.ustawSlajd = function (numer, zPrzejsciem) {
    if (numer !== this.indeks) this.zamknijAi(false);
    this.indeks = numer;
    this.tor.classList.toggle('bh-hero__track--przejscie', !!zPrzejsciem && !bezRuchu());
    this.tor.style.setProperty('--bh-hero-i', String(numer));
    this.tor.style.setProperty('--bh-hero-drag', '0px');

    for (var i = 0; i < this.slajdy.length; i += 1) {
      if (i === numer) this.slajdy[i].removeAttribute('inert');
      else this.slajdy[i].setAttribute('inert', '');
    }

    for (var j = 0; j < this.zakladki.length; j += 1) {
      if (j === numer) {
        this.zakladki[j].setAttribute('aria-selected', 'true');
        this.zakladki[j].setAttribute('tabindex', '0');
        this.zakladki[j].classList.add('bh-hero__tab--stoi');
        var nowe = this.zakladki[j].querySelector('[data-bh-hero-fill]');
        if (nowe) nowe.style.transform = 'translateX(-100%)';
      } else {
        this.zakladki[j].setAttribute('aria-selected', 'false');
        this.zakladki[j].setAttribute('tabindex', '-1');
        this.zakladki[j].classList.remove('bh-hero__tab--stoi');
        var stary = this.zakladki[j].querySelector('[data-bh-hero-fill]');
        if (stary) stary.style.transform = '';
      }
    }

    this.pokazZakladke();
  };

  Hero.prototype.pokazZakladke = function () {
    var aktywna = this.zakladki[this.indeks];
    if (!this.pasek || !aktywna) return;
    var api = window.BramoweHomeScroll;
    if (api && api.doPoziomo) api.doPoziomo(this.pasek, aktywna);
  };

  Hero.prototype.idzDo = function (numer) {
    var ile = this.slajdy.length;
    var cel = ((numer % ile) + ile) % ile;
    if (cel === this.indeks) return;
    this.zatrzymajLicznik();
    this.ustawSlajd(cel, true);
    this.moznaLiczyc();
  };

  Hero.prototype.chwyt = function (ev) {
    if (ev.pointerType === 'mouse' && ev.buttons !== 1) return;
    this.przeciaganie = { x: ev.clientX, y: ev.clientY, aktywne: false, id: ev.pointerId };
  };

  Hero.prototype.ruch = function (ev) {
    var p = this.przeciaganie;
    if (!p || p.id !== ev.pointerId) return;
    var dx = ev.clientX - p.x;
    var dy = ev.clientY - p.y;

    if (!p.aktywne) {
      if (Math.abs(dy) > Math.abs(dx)) { this.przeciaganie = null; return; }
      if (Math.abs(dx) < 10) return;
      p.aktywne = true;
      this.reczna();
      this.tor.classList.remove('bh-hero__track--przejscie');
    }

    var naSkraju = (this.indeks === 0 && dx > 0)
      || (this.indeks === this.slajdy.length - 1 && dx < 0);
    this.tor.style.setProperty('--bh-hero-drag', (naSkraju ? dx / 3 : dx) + 'px');
  };

  Hero.prototype.puszczenie = function (ev) {
    var p = this.przeciaganie;
    this.przeciaganie = null;
    if (!p || !p.aktywne) return;
    var dx = (ev.clientX || p.x) - p.x;
    if (dx <= -PROG_PRZECIAGNIECIA) this.ustawSlajd(Math.min(this.indeks + 1, this.slajdy.length - 1), true);
    else if (dx >= PROG_PRZECIAGNIECIA) this.ustawSlajd(Math.max(this.indeks - 1, 0), true);
    else this.ustawSlajd(this.indeks, true);
  };

  Hero.prototype.wypelnienie = function () {
    var z = this.zakladki[this.indeks];
    return z ? z.querySelector('[data-bh-hero-fill]') : null;
  };

  Hero.prototype.moznaLiczyc = function () {
    if (bezRuchu() || bezAutoodtwarzania() || this.wstrzymane) return;
    if (this.zFokusem || this.aiOtwarte || !this.wWidoku || document.hidden) return;
    if (this.slajdy.length < 2) return;
    var self = this;
    this.zatrzymajLicznik();

    var opoznienie = this.tor.classList.contains('bh-hero__track--przejscie') ? CZAS_PRZEJSCIA : 0;
    this.licznik = window.setTimeout(function () {
      self.startPaska();
      self.licznik = window.setTimeout(function () {
        self.idzDo(self.indeks + 1);
      }, self.czas);
    }, opoznienie);
  };

  Hero.prototype.startPaska = function () {
    var fill = this.wypelnienie();
    if (!fill) return;
    var zakladka = this.zakladki[this.indeks];
    zakladka.classList.add('bh-hero__tab--stoi');
    fill.style.transform = 'translateX(-100%)';
    void fill.offsetWidth;
    zakladka.classList.remove('bh-hero__tab--stoi');
    void fill.offsetWidth;
    fill.style.transform = '';
  };

  Hero.prototype.zamrozPasek = function () {
    var fill = this.wypelnienie();
    if (!fill) return;
    var zakladka = this.zakladki[this.indeks];
    var teraz = window.getComputedStyle(fill).transform;
    zakladka.classList.add('bh-hero__tab--stoi');
    fill.style.transform = teraz === 'none' ? 'translateX(-100%)' : teraz;
  };

  Hero.prototype.zatrzymajLicznik = function () {
    if (this.licznik) {
      window.clearTimeout(this.licznik);
      this.licznik = null;
    }
  };

  Hero.prototype.zamrozLicznik = function () {
    this.zatrzymajLicznik();
    this.zamrozPasek();
  };

  Hero.prototype.reczna = function () {
    if (this.wstrzymane) return;
    this.wstrzymaj();
  };

  Hero.prototype.wstrzymaj = function () {
    this.wstrzymane = true;
    this.zamrozLicznik();
    if (this.pauza) {
      this.pauza.setAttribute('aria-pressed', 'true');
      this.pauza.setAttribute('aria-label', this.pauza.getAttribute('data-label-play') || '');
    }
  };

  Hero.prototype.wznowPoWstrzymaniu = function () {
    if (this.wstrzymane) return;
    var zakladka = this.zakladki[this.indeks];
    if (zakladka) zakladka.classList.remove('bh-hero__tab--stoi');
    var fill = this.wypelnienie();
    if (fill) fill.style.transform = '';
    this.moznaLiczyc();
  };

  Hero.prototype.wznow = function () {
    this.wstrzymane = false;
    if (this.pauza) {
      this.pauza.setAttribute('aria-pressed', 'false');
      this.pauza.setAttribute('aria-label', this.pauza.getAttribute('data-label-pause') || '');
    }
    var zakladka = this.zakladki[this.indeks];
    if (zakladka) zakladka.classList.remove('bh-hero__tab--stoi');
    var fill = this.wypelnienie();
    if (fill) fill.style.transform = '';
    this.moznaLiczyc();
  };

  var instancje = new WeakMap();

  function uruchom(zakres) {
    var korzenie = (zakres || document).querySelectorAll('[data-bh-hero]');
    for (var i = 0; i < korzenie.length; i += 1) {
      if (instancje.has(korzenie[i])) continue;
      instancje.set(korzenie[i], new Hero(korzenie[i]));
    }
  }

  function zatrzymaj(zakres) {
    var korzenie = (zakres || document).querySelectorAll('[data-bh-hero]');
    for (var i = 0; i < korzenie.length; i += 1) {
      var instancja = instancje.get(korzenie[i]);
      if (instancja) {
        instancja.rozlacz();
        instancje.delete(korzenie[i]);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { uruchom(); });
  } else {
    uruchom();
  }

  document.addEventListener('shopify:section:load', function (ev) { uruchom(ev.target); });
  document.addEventListener('shopify:section:unload', function (ev) { zatrzymaj(ev.target); });
}());
